import React, { useState } from "react";
import "./MultiFileUpload.css";
import {
  Upload,
  Rejectedicon,
 
} from "../../../../../Components/IconComponents";
import PreviewFile from "../../Form/PreviewFile/PreviewFile";
import { validFileTypes } from "../FileUpload/fileUploadJson";
import { useTranslation } from "react-i18next";
import { VideoIcon } from "lucide-react";
 
function MultiFileUpload({
  label,
  name,
  errors,
  register,
  mandatory,
  handleFileChange,
  uploadfilewidth
}) {
  const [fileObjs, setFileObjs] = useState([]);
  const [showPreview, setShowPreview] = useState(false);
  const [previewFile, setPreviewFile] = useState(null);
  const [validMsg, setValidMsg] = useState(0);
  const { t } = useTranslation();
 
  const { onChange, ...registerParams } = register(name);
 
  // Supported file types - both images and videos
  const supportedTypes = [
    'image/jpeg',
    'image/png',
    'image/gif',
    'image/webp',
    'video/mp4',
    'video/webm',
    'video/ogg'
  ];
 
  const isImage = (fileType) => fileType.startsWith('image/');
  const isVideo = (fileType) => fileType.startsWith('video/');
 
  const handleFileChangeInternal = (event) => {
    const newFiles = Array.from(event.target.files);
 
    // Calculate total size of existing files
    const totalFileSize = fileObjs.reduce((sum, file) => sum + file.size, 0);
 
    // Filter valid files
    const filteredFiles = newFiles.filter((file) => {
      const isValidType = supportedTypes.includes(file.type);
      const isNotDuplicate = !fileObjs.some(f => f.name === file.name);
      const isWithinSizeLimit = (totalFileSize + file.size) <= 15000000; // 15MB
 
      return isValidType && isNotDuplicate && isWithinSizeLimit;
    });
 
    // Calculate new total size
    const totalSizeAfterUpload = filteredFiles.reduce(
      (sum, file) => sum + file.size,
      totalFileSize
    );
 
    setValidMsg(totalSizeAfterUpload);
 
    if (filteredFiles.length === 0) return;
 
    // Update local state
    const updatedFiles = [...fileObjs, ...filteredFiles];
    setFileObjs(updatedFiles);
 
    // Notify parent component
    if (handleFileChange) {
      handleFileChange({
        target: {
          name,
          files: updatedFiles
        }
      });
    }
 
    // Notify React Hook Form
    if (onChange) {
      onChange({
        target: {
          name,
          value: updatedFiles
        }
      });
    }
  };
 
  const previewHandler = (file) => {
    setPreviewFile(file);
    setShowPreview(true);
  };
 
  const removeFile = (fileIndex) => {
    const newFiles = fileObjs.filter((_, index) => index !== fileIndex);
    setFileObjs(newFiles);
 
    // Notify parent component
    if (handleFileChange) {
      handleFileChange({
        target: {
          name,
          files: newFiles
        }
      });
    }
 
    // Notify React Hook Form
    if (onChange) {
      onChange({
        target: {
          name,
          value: newFiles
        }
      });
    }
  };
 
  const triggerFileInput = () => {
    const fileInput = document.getElementById(name);
    if (fileInput) fileInput.click();
  };
 
  const handleDrop = (event) => {
    event.preventDefault();
    const dt = event.dataTransfer;
    if (dt.files && dt.files.length) {
      handleFileChangeInternal({ target: { files: dt.files } });
    }
  };
 
  const handleDragOver = (event) => {
    event.preventDefault();
  };
 
  return (
    <div className="sales__upload">
      <label className="form__label">
        {t(label)}
        {mandatory && <span className="asterisk">*</span>}
      </label>
 
      <div className="multifile-all_card_view">
        {/* File preview thumbnails */}
        {fileObjs.map((file, index) => (
          <div
            key={`${file.name}-${index}`}
            style={{
              position: 'relative',
              width: '120px',
              margin: '8px'
            }}
          >
            <div style={{
              position: 'relative',
              width: '100%',
              height: '120px',
              display: 'flex',
              flexDirection: 'column'
            }}>
              <div
                style={{
                  position: 'absolute',
                  top: '4px',
                  right: '4px',
                  zIndex: 1,
                 
                  borderRadius: '50%',
                  padding: '2px',
                  boxShadow: '0 1px 3px rgba(56, 54, 54, 0.2)',
                  cursor: 'pointer'
                }}
                onClick={() => removeFile(index)}
              >
                <Rejectedicon width="1rem" height="1rem" />
              </div>
              <div style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                flexDirection: 'column'
              }}>
                <div
                  style={{
                    flex: 1,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    overflow: 'hidden',
                    background: '#f5f5f5',
                    borderRadius: '4px',
                    cursor: 'pointer'
                  }}
                  onClick={() => previewHandler(file)}
                >
                  {isImage(file.type) ? (
                    <img
                      src={URL.createObjectURL(file)}
                      style={{
                        maxWidth: '100%',
                        maxHeight: '100%',
                        objectFit: 'contain'
                      }}
                      alt={file.name}
                    />
                  ) : isVideo(file.type) ? (
                    <div style={{
                      width: '100%',
                      height: '100%',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      background: '#1e2127ff'
                    }}>
                      <VideoIcon width="2rem" height="2rem" />
                    </div>
                  ) : null}
                </div>
                <div style={{
                  marginTop: '4px',
                  width: '100%',
                  minHeight: '40px',
                  display: 'flex',
                  alignItems: 'center'
                }}>
                  <span style={{
                    fontSize: '12px',
                    lineHeight: 1.3,
                    wordBreak: 'break-word',
                    textAlign: 'center',
                    width: '100%',
                    display: '-webkit-box',
                    WebkitLineClamp: 3,
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis'
                  }}>
                    {file.name}
                  </span>
                </div>
              </div>
            </div>
          </div>
        ))}
 
        {/* File preview modal */}
        {!uploadfilewidth && showPreview && (
          <PreviewFile
            file={previewFile}
            show={showPreview}
            previewHandler={() => setShowPreview(false)}
            title="File Preview"
          />
        )}
 
        {/* Upload area */}
        <div
          className="multi_file_upload cursor-pointer"
          onDragOver={handleDragOver}
          onDrop={handleDrop}
          onClick={triggerFileInput}
          style={{ width: uploadfilewidth ? '100%' : 'auto' }}
        >
          <div className="upload-content">
            <div className="icon__size--multifile">
              <Upload />
            </div>
            <div className="multi-file_text">
              {uploadfilewidth ? t("Upload files (JPEG, PNG, MP4)") : t("Drag and drop here or browse")}
            </div>
          </div>
 
          <input
            id={name}
            type="file"
            name={name}
            style={{ display: "none" }}
            onChange={handleFileChangeInternal}
            multiple
            accept={uploadfilewidth ? "image/*,video/*" : supportedTypes.join(",")}
            {...registerParams}
          />
        </div>
      </div>
 
      {/* Validation messages */}
      {validMsg > 15000000 && (
        <span className="error__message">
          {t("Total file size should not exceed 15MB")}
        </span>
      )}
      {errors[name]?.message && (
        <span className="error__message">{errors[name]?.message}</span>
      )}
    </div>
  );
}
 
export default MultiFileUpload;